export interface TaskAction {
    actionId: number | string;
    code: number | string;
    notes?: string;
    expectedDuration?: number;
    link?: string
}

export interface TaskActionFilter {
    options: {
    },
    cache: {
    },
    values: {
    },
    applied: {
    }
}

export function getDefaultTaskAction(): TaskAction {
    return structuredClone({
        actionId: '',
        code: ''
    })
}